module.exports = __webpack_public_path__ + "static/img/6.3de7de9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/sp/6.png
// module id = Itx7
// module chunks = 0